import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Junta classes resolvendo conflitos do Tailwind (a última vence de verdade).
 * Sem o merge, `cn('p-4', 'p-6')` emitiria as duas e o resultado dependeria da ordem no CSS.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
